export const setCaret = (target: HTMLElement) => {
  const range = document.createRange();
  const sel = window.getSelection();
  range.selectNodeContents(target);
  range.collapse(false);
  sel?.removeAllRanges();
  sel?.addRange(range);
  range.detach();
};
